import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ProfileService } from '../../services/profile.service';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { ProfileModuleConsts } from '../../conatants';
import { AlertService } from 'src/app/core/services/alert.service';
import { filter } from 'rxjs/operators';
import {AuthLoginService} from 'src/app/user/services/auth-login.service';
@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    standalone: false
})
export class ChangePasswordComponent implements OnInit {
  fieldTextType: boolean;
  fieldTextType1: boolean;
  fieldTextType2: boolean;
  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }
  toggleFieldTextType1() {
    this.fieldTextType1 = !this.fieldTextType1;
  }
  toggleFieldTextType2() {
    this.fieldTextType2 = !this.fieldTextType2;
  }

  changePasswordForm: FormGroup;
  profileModuleConstant = ProfileModuleConsts;
  submitted = false;
  errMessage: any;
  confirmErrMessage: any;
  serverErrMessage: any;
  hide: boolean =false;
  hide1 : boolean =false;
  hide2 : boolean =false;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private profileService: ProfileService,
    private statePersist: StatePersistService,
    private toasterService: AlertService,
    private authServiceLogin:AuthLoginService,
    private titleService: Title,
    private route: ActivatedRoute
  ) {
    const body = document.getElementsByTagName('body')[0];
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(res => {
      if (this.router.url == "/profile/change-password") {
        body.classList.add('adjust-logo');
      }
      else {
        body.classList.remove('adjust-logo');
      }
    });
   }

  ngOnInit() {
    this.statePersist.setLocalStorage('address-disabled', true)
    this.statePersist.setLocalStorage('retailer-disabled', true)
    this.statePersist.setLocalStorage('product_data', {}, 'search')
    this.statePersist.removeLocalStorage('product_data')
    
    this.changePasswordForm = this.formBuilder.group({
      old_password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(15)]],
      new_password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(15)]],
      confirm_password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(15)]],
    });
    this.titleService.setTitle('World of Sweets - Reset Password');

    this.changePasswordForm.get('old_password').valueChanges
      .subscribe(old_password => {
        if (old_password) {
          this.errMessage = '';
        }
      });

    this.changePasswordForm.get('confirm_password').valueChanges
      .subscribe(confirm_password => {
        const new_password = this.changePasswordForm.controls.new_password.value;
        if (confirm_password === new_password) {
          this.confirmErrMessage = '';
        } else {
          this.confirmErrMessage = 'Confirm Password not matched with New password';
        }
      });

    this.changePasswordForm.get('new_password').valueChanges
      .subscribe(new_password => {
        const confirm_password = this.changePasswordForm.controls.confirm_password.value;
        if (confirm_password) {
          if (confirm_password === new_password) {
            this.confirmErrMessage = '';
          } else {
            this.confirmErrMessage = 'Confirm Password not matched with New password';
          }
        }
      });

  }

  changePassword() {
    this.submitted = true;
    const newPassword = this.changePasswordForm.controls.new_password.value;
    const confPassword = this.changePasswordForm.controls.confirm_password.value;
    if (newPassword !== confPassword) {
      this.serverErrMessage = 'Confirm Password not matched with New password';
      return;
    }
    if (this.changePasswordForm.invalid) {
      return;
    }
    const encrypted_old_password = this.authServiceLogin.createHashedPassword(this.changePasswordForm.controls.old_password.value);
    const encrypted_new_password = this.authServiceLogin.createHashedPassword(this.changePasswordForm.controls.new_password.value);
    this.profileService.changePassword(encrypted_old_password, encrypted_new_password)
    .subscribe(
      data => {
          if (data['status'] === 111){
            if (data['message'].old_password[0] === 'Please enter correct existing password.') {
              this.serverErrMessage = data['message'].old_password;
            }
          }
          else{
            this.toasterService.success('Password has been changed successfully')
            this.router.navigate(['home']);
          }
          
        },
        error => {
          const error_object = JSON.parse(error);
          if (error_object.status === 111) {
            if (error_object.message.old_password[0] === 'Please enter correct existing password.') {
              this.serverErrMessage = error_object.message.old_password;
            }
          }
        }
      );
  }

  redirectToHome() {
    this.router.navigate(['/']);
  }
}
